(function () {

  'use strict';


  /* =========================================================
     INITIALIZE
  ========================================================= */

  function initFamilyCombo(root) {

    if (!root) {
      return;
    }

    if (root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    const productGroups =
      root.querySelector(
        '[data-product-groups]'
      );

    const totalElement =
      root.querySelector(
        '[data-family-total]'
      );

    const cartButton =
      root.querySelector(
        '[data-family-add-to-cart]'
      );

    const messageElement =
      root.querySelector(
        '[data-family-message]'
      );

    if (!productGroups) {
      return;
    }


    /* =======================================================
       PRODUCTS
    ======================================================= */

    const products = {};

    root
      .querySelectorAll(
        '[data-product-json]'
      )
      .forEach(function (script) {

        try {

          const product =
            JSON.parse(
              script.textContent.trim()
            );

          products[
            String(product.id)
          ] = product;

        } catch (error) {

          console.error(
            'Family Combo: Product data error',
            error
          );

        }

      });


    /* =======================================================
       SIZE CHART MODAL
    ======================================================= */

    const sizeChartModal =
      document.createElement('div');

    sizeChartModal.className =
      'family-combo__size-chart-modal';

    sizeChartModal.hidden = true;

    sizeChartModal.innerHTML = `
      <div
        class="family-combo__size-chart-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Size Chart"
      >

        <button
          type="button"
          class="family-combo__size-chart-close"
          data-size-chart-close
          aria-label="Close size chart"
        >
          ×
        </button>

        <img
          class="family-combo__size-chart-image"
          data-size-chart-image
          src=""
          alt="Size Chart"
        >

      </div>
    `;

    root.appendChild(sizeChartModal);

    const sizeChartImage =
      sizeChartModal.querySelector(
        '[data-size-chart-image]'
      );

    const closeSizeChart =
      function () {

        sizeChartModal.hidden = true;

        sizeChartImage.removeAttribute('src');

        document.body.style.overflow = '';

      };

    const openSizeChart =
      function (url, title) {

        if (!url) {
          return;
        }

        sizeChartImage.src = url;

        sizeChartImage.alt =
          (title || 'Size Chart') + ' Size Chart';

        sizeChartModal.hidden = false;

        document.body.style.overflow = 'hidden';

      };

    sizeChartModal.addEventListener(
      'click',
      function (event) {

        if (
          event.target === sizeChartModal ||
          event.target.closest('[data-size-chart-close]')
        ) {

          closeSizeChart();

        }

      }
    );

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key === 'Escape' &&
          !sizeChartModal.hidden
        ) {

          closeSizeChart();

        }

      }
    );


    /* =======================================================
       MONEY
    ======================================================= */

    function formatMoney(cents) {

      try {

        return new Intl.NumberFormat(
          'en-IN',
          {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0
          }
        ).format(
          Number(cents) / 100
        );

      } catch (error) {

        return '₹' +
          Math.round(
            Number(cents) / 100
          );

      }

    }


    /* =======================================================
       ESCAPE HTML
    ======================================================= */

    function escapeHtml(value) {

      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    }


    /* =======================================================
       MESSAGES
    ======================================================= */

    function showMessage(message) {

      if (!messageElement) {
        return;
      }

      messageElement.textContent =
        message;

      messageElement.hidden =
        false;

    }


    function clearMessage() {

      if (!messageElement) {
        return;
      }

      messageElement.textContent =
        '';

      messageElement.hidden =
        true;

    }


    /* =======================================================
       CREATE VARIANT ROW
    ======================================================= */

    function createVariantRow(product) {

      const row =
        document.createElement('div');

      row.className =
        'family-combo__variant-row';

      row.dataset.variantRow =
        'true';

      let options = `
        <option value="">
          Select variant
        </option>
      `;

      product.variants.forEach(
        function (variant) {

          const disabled =
            variant.available
              ? ''
              : 'disabled';

          const soldOut =
            variant.available
              ? ''
              : ' - Sold out';

          options += `
            <option
              value="${variant.id}"
              data-price="${variant.price}"
              ${disabled}
            >
              ${escapeHtml(
                variant.title
              )}${soldOut}
            </option>
          `;

        }
      );

      row.innerHTML = `

        <select
          class="family-combo__variant-select"
          data-variant-select
        >
          ${options}
        </select>

        <div
          class="family-combo__variant-price"
          data-variant-price
        ></div>

        <button
          type="button"
          class="family-combo__remove"
          data-remove-variant
        >
          × Remove
        </button>

      `;

      const select =
        row.querySelector(
          '[data-variant-select]'
        );

      const removeButton =
        row.querySelector(
          '[data-remove-variant]'
        );

      const priceElement =
        row.querySelector(
          '[data-variant-price]'
        );


      /* -------------------------------------------------------
         VARIANT CHANGE + PRICE
      ------------------------------------------------------- */

      select.addEventListener(
        'change',
        function () {

          const option =
            select.options[
              select.selectedIndex
            ];

          if (
            option &&
            option.value &&
            option.dataset.price
          ) {

            const price =
              Number(
                option.dataset.price
              );

            priceElement.textContent =
              formatMoney(price);

            priceElement.classList.add(
              'is-visible'
            );

          } else {

            priceElement.textContent =
              '';

            priceElement.classList.remove(
              'is-visible'
            );

          }

          updateTotal();

          clearMessage();

        }
      );


      /* -------------------------------------------------------
         REMOVE VARIANT
      ------------------------------------------------------- */

      removeButton.addEventListener(
        'click',
        function () {

          /*
           * Only this variant row is removed.
           * The product card stays.
           */

          row.remove();

          updateTotal();

          clearMessage();

        }
      );

      return row;

    }


    /* =======================================================
       CREATE PRODUCT CARD
    ======================================================= */

    function createProductCard(product) {

      const card =
        document.createElement('div');

      card.className =
        'family-combo__product';

      card.dataset.productId =
        String(product.id);

      card.innerHTML = `

        <div
          class="family-combo__product-main"
        >

          <div
            class="family-combo__product-image"
          >

            ${
              product.image
                ? `
                  <img
                    src="${product.image}"
                    alt="${escapeHtml(
                      product.title
                    )}"
                    loading="lazy"
                  >
                `
                : ''
            }

          </div>

          <div
            class="family-combo__product-content"
          >

            <h3
              class="family-combo__product-title"
            >
              ${escapeHtml(
                product.title
              )}
            </h3>

            <div
              class="family-combo__variants"
              data-variant-container
            ></div>

            <button
              type="button"
              class="family-combo__add-more"
              data-add-more
            >

              <span
                class="family-combo__plus"
              >
                +
              </span>

              Add More

            </button>

            ${
              product.sizeChart
                ? `
                  <button
                    type="button"
                    class="family-combo__size-chart"
                    data-size-chart
                  >
                    View Size Chart
                  </button>
                `
                : ''
            }

          </div>

        </div>

      `;

      const variantContainer =
        card.querySelector(
          '[data-variant-container]'
        );

      const addMoreButton =
        card.querySelector(
          '[data-add-more]'
        );


      /* -------------------------------------------------------
         INITIAL VARIANT
      ------------------------------------------------------- */

      variantContainer.appendChild(
        createVariantRow(product)
      );


      /* -------------------------------------------------------
         ADD MORE
      ------------------------------------------------------- */

      addMoreButton.addEventListener(
        'click',
        function () {

          const newRow =
            createVariantRow(product);

          variantContainer.appendChild(
            newRow
          );

          clearMessage();

          setTimeout(
            function () {

              newRow.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });

            },
            50
          );

        }
      );


      /* -------------------------------------------------------
         SIZE CHART
      ------------------------------------------------------- */

      const sizeChartButton =
        card.querySelector(
          '[data-size-chart]'
        );

      if (
        sizeChartButton &&
        product.sizeChart
      ) {

        sizeChartButton.addEventListener(
          'click',
          function () {

            openSizeChart(
              product.sizeChart,
              product.title
            );

          }
        );

      }


      return card;

    }


    /* =======================================================
       INITIAL PRODUCT CARDS
    ======================================================= */

    root
      .querySelectorAll(
        '[data-initial-product]'
      )
      .forEach(
        function (element) {

          const productId =
            String(
              element.dataset.initialProduct
            );

          const product =
            products[productId];

          if (!product) {
            return;
          }

          const card =
            createProductCard(product);

          productGroups.appendChild(
            card
          );

        }
      );


    /* =======================================================
       UPDATE TOTAL
    ======================================================= */

    function updateTotal() {

      let total = 0;

      root
        .querySelectorAll(
          '[data-variant-select]'
        )
        .forEach(
          function (select) {

            const option =
              select.options[
                select.selectedIndex
              ];

            if (
              option &&
              option.value &&
              option.dataset.price
            ) {

              total +=
                Number(
                  option.dataset.price
                );

            }

          }
        );

      if (totalElement) {

        totalElement.textContent =
          formatMoney(total);

      }

    }


    /* =======================================================
       ADD TO CART
    ======================================================= */

    if (cartButton) {

      cartButton.addEventListener(
        'click',
        async function () {

          clearMessage();

          const items = [];

          const cards =
            productGroups.querySelectorAll(
              '.family-combo__product'
            );

          let hasEmptyVariant =
            false;

          cards.forEach(
            function (card) {

              const productId =
                String(
                  card.dataset.productId
                );

              const product =
                products[productId];

              if (!product) {
                return;
              }

              const selects =
                card.querySelectorAll(
                  '[data-variant-select]'
                );

              selects.forEach(
                function (select) {

                  if (!select.value) {

                    hasEmptyVariant =
                      true;

                    return;

                  }

                  items.push({

                    id:
                      Number(
                        select.value
                      ),

                    quantity: 1,

                    properties: {

                      '_family_combo':
                        'true',

                      '_family_item':
                        product.title

                    }

                  });

                }
              );

            }
          );


          if (hasEmptyVariant) {

            showMessage(
              'Please select a variant for every item.'
            );

            return;

          }


          if (!items.length) {

            showMessage(
              'Please select at least one variant.'
            );

            return;

          }


          cartButton.disabled =
            true;

          const originalText =
            cartButton.textContent;

          cartButton.textContent =
            'Adding to cart...';


          try {

            const rootPath =
              window.Shopify &&
              window.Shopify.routes &&
              window.Shopify.routes.root
                ? window.Shopify.routes.root
                : '/';

            const response =
              await fetch(
                rootPath + 'cart/add.js',
                {
                  method: 'POST',

                  headers: {
                    'Content-Type':
                      'application/json',

                    'Accept':
                      'application/json'
                  },

                  body:
                    JSON.stringify({
                      items: items
                    })
                }
              );

            const data =
              await response.json();

            if (!response.ok) {

              throw new Error(
                data.description ||
                data.message ||
                'Unable to add products to cart.'
              );

            }

            window.location.href =
              rootPath + 'cart';


          } catch (error) {

            console.error(
              'Family Combo Cart Error:',
              error
            );

            showMessage(
              error.message ||
              'Something went wrong. Please try again.'
            );

            cartButton.disabled =
              false;

            cartButton.textContent =
              originalText;

          }

        }
      );

    }


    /* =======================================================
       INITIAL TOTAL
    ======================================================= */

    updateTotal();

  }


  /* =========================================================
     INITIALIZE ALL
  ========================================================= */

  function initAll() {

    document
      .querySelectorAll(
        '[data-family-combo]'
      )
      .forEach(
        function (root) {

          initFamilyCombo(root);

        }
      );

  }


  /* =========================================================
     DOM READY
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const root =
        event.target.querySelector(
          '[data-family-combo]'
        );

      if (root) {

        initFamilyCombo(root);

      }

    }
  );


})();